import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import Input from '../../Form/Input';

interface CandidateFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  nationality: string;
  dateOfBirth: string;
  [key: string]: any;
}

interface CandidatePersonalInfoProps {
  register: UseFormRegister<CandidateFormData>;
  errors: FieldErrors<CandidateFormData>;
}

const CandidatePersonalInfo: React.FC<CandidatePersonalInfoProps> = ({ register, errors }) => {
  return (
    <div className="border-b border-gray-200 pb-6">
      <h4 className="text-md font-medium text-gray-900 mb-4">Personal Information</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="First Name *"
          {...register('firstName', { required: 'First name is required' })}
          error={errors.firstName?.message}
          placeholder="e.g., Ahmed"
        />

        <Input
          label="Last Name *"
          {...register('lastName', { required: 'Last name is required' })}
          error={errors.lastName?.message}
          placeholder="e.g., Hassan"
        />

        <Input
          label="Email *"
          type="email"
          {...register('email', { 
            required: 'Email is required',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Invalid email address'
            }
          })}
          error={errors.email?.message}
          placeholder="e.g., ahmed.hassan@email.com"
        />

        <Input
          label="Phone *"
          {...register('phone', { required: 'Phone number is required' })}
          error={errors.phone?.message}
          placeholder="e.g., +20-123-456-7890"
        />

        <Input
          label="Nationality *"
          {...register('nationality', { required: 'Nationality is required' })}
          error={errors.nationality?.message}
          placeholder="e.g., Egyptian"
        />

        <Input
          label="Date of Birth *"
          type="date"
          {...register('dateOfBirth', { required: 'Date of birth is required' })}
          error={errors.dateOfBirth?.message}
        />
      </div>
    </div>
  );
};

export default CandidatePersonalInfo;
